<template>
  <div class="footer">
    <DefGoToTop />
    <FooterMiniBanner v-if="footerMiniBanner.doShowMiniBanner" :result="footerMiniBanner" />
    <LoveYouClubWrapper v-if="1" />
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import DefGoToTop from '@components/Def/DefGoToTop/DefGoToTop.vue';
import FooterMiniBanner from '@components/Footer/FooterMiniBanner.vue';
import useModal from '@use/useModal/useModal';
import SignInUpdate from '@components/Cabinet/Entry/SignInPhoneUpdate/SignInUpdate.vue';
import LoveYouClubWrapper from '@components/LoveYouClub/LoveYouClubWrapper.vue';

export default {
  name: 'Footer',
  components: { FooterMiniBanner, DefGoToTop, LoveYouClubWrapper },
  props: ['result'],
  data() {
    return {
      modal: useModal(),
    };
  },
  computed: {
    ...mapState({
      footerMiniBanner: ({ footerMiniBanner }) => footerMiniBanner?.data,
      user: ({ personal }) => personal.data?.authInfo,
      personal: ({ personal }) => personal.data,
      messages: ({ results }) => results.messages.entry,
    }),
  },
  methods: {
    ...mapActions({
      getBackBasketItems: 'basket/getBackBasketItems',
      refreshMiniBanner: 'footerMiniBanner/refresh',
    }),
    ...mapMutations({
      setError: 'personal/setError',
    }),
    removeIPostDataFromStorage() {
      this.getBackBasketItems();
    },
    /**
     * @todo move to personal.js
     */
    showUpdatePhoneModal() {
      if (this.user.isAuthorized && !this.user.user_phone_number) {
        const closeModalError = this.messages?.closeModalError;
        this.modal.show(
          SignInUpdate,
          {
            response: {
              id: this.user.user_id,
              phone: this.user.userPersonalPhone,
            },
          },
          {
            width: '340px',
            isShowClose: false,
            backgroundClose: () => {
              this.setError({ closeModalError });
            },
          }
        );
      }
    },
  },
  created() {
    this.removeIPostDataFromStorage();
  },
  mounted() {
    this.refreshMiniBanner(location.pathname);
    this.showUpdatePhoneModal();
  },
};
</script>

<style lang="scss" scoped>
.footer {
}
</style>
